import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function Hero() {
  return <section className="w-full bg-background px-5 pb-12 pt-4 sm:pb-20 sm:pt-10" style={{
    paddingTop: '15px'
  }} data-id="element-125" data-mp="9lbfcytwl7cj">
      <div className="mx-auto max-w-4xl text-center" data-id="element-126" data-mp="4jvw9cbadaws">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT
      }} className="text-[11px] font-bold uppercase leading-tight tracking-[0.18em] text-success sm:text-xs sm:tracking-[0.22em]" data-id="element-127" data-mp="12860zz2gicrl">
          Le curriculum de musique complet pour les enseignants francophones
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: EASE_OUT
      }} className="mt-3 font-display text-[2.25rem] font-black leading-[1.06] tracking-tight text-foreground sm:mt-5 sm:text-[3.4rem] md:text-[4rem]" data-id="element-128" data-mp="3d2ldtocrhr6i">
          Préparez une Année Entière de Cours de Musique en seulement{' '}
          <span className="italic text-emphasis" data-id="element-129" data-mp="399tej4gk2sde">5&nbsp;Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: EASE_OUT
      }} className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-foreground/60 sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-130" data-mp="3e84orgarj4w5">
          <span className="sm:hidden" data-id="element-131" data-mp="2qleookhz5ke6">
            9 volumes PDF prêts à l&apos;emploi, du CP à la 3ème. Imprimez,
            ouvrez et enseignez.
          </span>
          <span className="hidden sm:inline" data-id="element-132" data-mp="2hinc2hdd4iky">
            Musique Prête™ est le système complet «&nbsp;clé en main&nbsp;»&nbsp;:
            9 volumes PDF prêts à l&apos;emploi remplis de théorie visuelle,
            d&apos;activités pratiques et d&apos;évaluations du CP à la 3ème. Il
            suffit d&apos;imprimer, d&apos;ouvrir et d&apos;enseigner.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.15,
        ease: EASE_OUT
      }} className="mx-auto mt-3 max-w-2xl sm:mt-10" data-id="element-133" data-mp="ibozao1l0svy">
          <img src="https://cdn.magicpatterns.com/uploads/1DUo6VYffAeaBLLJECBYMz/2cc7f8ae-5225-4af2-851f-f299a251263a.webp" alt="Le pack Musique Prête™ : 9 volumes, la version numérique sur ordinateur, tablette et téléphone et les 5 bonus" className="mx-auto max-h-[34vh] w-full object-contain sm:max-h-none" data-id="element-134" data-mp="1b04cr652f356" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: EASE_OUT
      }} className="mt-3 sm:mt-8" data-id="element-135" data-mp="3lu07neppzt62">
          <CtaButton href="#offerta" data-id="element-136" data-mp="1xavviebxdy4m" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold text-foreground/55 sm:mt-5 sm:gap-x-3 sm:gap-y-2 sm:text-xs" data-id="element-137" data-mp="21awf0ddvszij">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-2 sm:gap-3" data-id="element-138" data-mp="2b1rbeakudfhp" data-mpi={index}>
                <span data-id="element-139" data-mp="2g02iidjr5bw8">
                  <span aria-hidden="true" className="text-success" data-id="element-140" data-mp="2fyr65pc8qvti">
                    ✓{' '}
                  </span>
                  {item}
                </span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-foreground/25" data-id="element-141" data-mp="2p10imkr2kz9j">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}